import {useSelector} from "react-redux";
import useInterval from "../../utils/useInterval";

const notificationSoundDelay = 3000

function toggleNotificationSound() {
    const audioEl = document.getElementsByClassName("audio-element")[0]
    audioEl.muted = false;
    audioEl.play();
}

const SoundNotifications = () => {

    const { orderUpdates, orderPending, allowSound } = useSelector(({ orders }) => orders);

    const play = (!!orderPending.length || !!orderUpdates.length) && allowSound
    useInterval(()=> {
        toggleNotificationSound()
    }, play ? notificationSoundDelay : null)

    return null
}

export default SoundNotifications
